export const ORDER_BY_OPTIONS = {
  column: 'recruiterName',
  direction: 'asc'
};
